{
  "email-phone-confirmation-pin-dialog": {
    "buttons": {
      "resend": "Gửi lại",
      "submit": "Xác nhận"
    },
    "text": {
      "email-confirmation": "Xác minh Email",
      "enter-to-confirm-email": "Vui lòng nhập mã PIN để xác nhận email của bạn",
      "enter-to-confirm-phone": "Vui lòng nhập mã PIN để xác nhận số điện thoại của bạn",
      "in-second": "sau {{seconds}} giây",
      "phone-confirmation": "Xác minh số điện thoại",
      "pin-sent-to-email": "Mã PIN được gửi tới email của bạn",
      "pin-sent-to-phone": "Mã PIN được gửi tới số điện thoại của bạn",
      "update-success": "Cập nhật thành công!"
    }
  }
}
